'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import CustomWidgetField from 'DesignData/models/CustomWidgetField';
import { DEFAULT } from 'DesignData/enums/CustomWidgetFieldAttributes';
import { GRADIENT } from 'ContentUtils/constants/CustomWidgetFieldTypes';
import Gradient from 'ContentComponents/cmv2/fields/Gradient';
import SidebarInput from 'DesignEditorsUI/components/shared/sidebar/SidebarInput';
import ToolFormControl from 'DesignComponents/tool/ToolFormControl';

const i18nKey = key => `DesignEditorsUI.customWidgetEditor.sidebar.fieldEdit.contentOptions.${key}`;

class GradientContentOptions extends Component {
  constructor(props) {
    super(props);
    this.onDefaultChange = this.onDefaultChange.bind(this);
  }

  onDefaultChange(value) {
    this.props.editField({
      [DEFAULT]: value
    });
  }

  render() {
    const {
      field,
      readOnly
    } = this.props;
    return /*#__PURE__*/_jsx(ToolFormControl, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey(`defaultLabels.${GRADIENT}`)
      }),
      children: /*#__PURE__*/_jsx(SidebarInput, {
        inputComponent: Gradient,
        onFieldChange: this.onDefaultChange,
        value: field[DEFAULT] && field[DEFAULT].asMutable({
          deep: true
        }),
        readOnly: readOnly
      })
    });
  }

}

GradientContentOptions.propTypes = {
  editField: PropTypes.func.isRequired,
  field: PropTypes.instanceOf(CustomWidgetField).isRequired,
  readOnly: PropTypes.bool
};
export default GradientContentOptions;